import { useRef, useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import RankingResultadoCard from './RankingResultadoCard';

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

const IconDownload = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

export default function ModalResultadoRanking({ resultado, onClose }) {
  const cardRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [gerando, setGerando] = useState(true);

  const month = new Date(resultado.month + 'T00:00:00Z');
  const mesNome = MESES[month.getUTCMonth()];

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  // Gera o PNG a partir do card off-screen (padrão MetricasComunidade)
  useEffect(() => {
    if (!cardRef.current) return;
    let cancelled = false;
    setGerando(true);

    async function gerar() {
      try { await document.fonts.ready; } catch {}
      await new Promise(r => setTimeout(r, 150));
      if (cancelled || !cardRef.current) { setGerando(false); return; }
      try {
        const canvas = await html2canvas(cardRef.current, {
          scale: 3,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#1a1838',
          logging: false,
          foreignObjectRendering: false,
        });
        if (!cancelled) setPreviewUrl(canvas.toDataURL('image/png'));
      } catch {
        // sem preview, mas botão de download não aparece
      } finally {
        if (!cancelled) setGerando(false);
      }
    }

    gerar();
    return () => { cancelled = true; };
  }, []);

  function handleDownload() {
    if (!previewUrl) return;
    const link = document.createElement('a');
    link.download = `ranking-${mesNome.toLowerCase()}.png`;
    link.href = previewUrl;
    link.click();
  }

  async function handleShare() {
    if (!previewUrl) return;
    try {
      const res = await fetch(previewUrl);
      const blob = await res.blob();
      const file = new File([blob], `ranking-${mesNome.toLowerCase()}.png`, { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: `Meu resultado de ${mesNome} — Clube do Eu` });
        return;
      }
      handleDownload();
    } catch {
      handleDownload();
    }
  }

  return (
    <>
      {/* Card off-screen para captura — igual ao padrão MetricasComunidade */}
      <div style={{ position: 'fixed', overflow: 'hidden', width: 0, height: 0, top: 0, left: 0, pointerEvents: 'none', zIndex: -1 }}>
        <RankingResultadoCard ref={cardRef} resultado={resultado} />
      </div>

      <div className="yrr-overlay" onClick={onClose}>
        <div className="yrr-sheet" onClick={e => e.stopPropagation()}>
          <div className="yrr-header">
            <h3 className="yrr-titulo">Seu resultado de {mesNome}</h3>
            <button className="yrr-fechar" onClick={onClose} aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div className="yrr-card-wrap">
            {gerando ? (
              <div className="yrr-loading">Gerando imagem...</div>
            ) : previewUrl ? (
              <img src={previewUrl} alt={`Resultado de ${mesNome}`} className="yrr-preview-img" />
            ) : null}
          </div>

          <div className="yrr-actions">
            <button
              className="btn btn-primary yrr-btn-download"
              onClick={handleShare}
              disabled={!previewUrl || gerando}
            >
              <IconDownload /> Baixar imagem
            </button>
            <button className="btn btn-ghost" style={{ width: '100%' }} onClick={onClose}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
